import { useQuery, useSuspenseQuery } from "@tanstack/react-query";
import { ProductRequestSchemas } from "api-types";
import { axiosClient, useAxios } from "auth-sdk";
import type { AxiosResponse } from "axios";

import { useOfferRequestPath } from "../hooks";

const useDealOwnerQueryOptions = (productRequestId: string) => {
  const client = useAxios();
  const requestPath = useOfferRequestPath().getDealOwner(productRequestId);

  return {
    queryKey: ["getDealOwner"],
    queryFn: () => client.get<ProductRequestSchemas.DealOwnerProfile>(requestPath),
    select: ({ data }: AxiosResponse): ProductRequestSchemas.DealOwnerProfile => data,
  };
};

export const useGetDealOwnerQuery = (productRequestId: string) =>
  useQuery({ ...useDealOwnerQueryOptions(productRequestId), throwOnError: true });

export const useSuspenseGetDealOwnerQuery = (productRequestId: string) =>
  useSuspenseQuery(useDealOwnerQueryOptions(productRequestId));

export const getDealOwnerQueryOptions = (customerDomain: string, productRequestId?: string | null | undefined) => {
  const requestPath = `/${customerDomain}/offers/api/product-request/${productRequestId}/deal-owner`;

  return {
    queryKey: ["getDealOwner", productRequestId, customerDomain],
    queryFn: () => axiosClient.get<ProductRequestSchemas.DealOwnerProfile>(requestPath),
    select: ({ data }: AxiosResponse): ProductRequestSchemas.DealOwnerProfile => data,
    enabled: !!productRequestId,
  };
};

export const getCompanyDealOwnerQueryOptions = (customerDomain: string) => {
  const requestPath = `/${customerDomain}/product-request/api/company/deal-owner`;

  return {
    queryKey: ["getCompanyDealOwner", customerDomain],
    queryFn: () => axiosClient.get<ProductRequestSchemas.DealOwnerProfile>(requestPath),
    select: ({ data }: AxiosResponse): ProductRequestSchemas.DealOwnerProfile => data,
  };
};
